import { useContext, useState } from "react";
import { Context } from "../../../context/context";
import { Box, Button, Modal } from "@mui/material";
import RegisterUser from "../../../components/Modal/RegisterUser/RegisterUser";
import UserTable from "../../../components/Tables/UserTable/UserTable";
import { modalStyle } from "../../../utils/modal-style";

export default function Users() {
  const { sidebar } = useContext(Context);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  //
  return (
    <>
      <main className={sidebar ? "container" : "container-full"}>
        <Button
          size="medium"
          style={{ width: "250px" }}
          variant="contained"
          onClick={handleOpen}
          className="new-user"
        >
          Cadastrar novo usuário
        </Button>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={modalStyle} className="box-modal">
            <RegisterUser setOpen />
          </Box>
        </Modal>

        <div className="table-container">
          <UserTable />
        </div>
      </main>
    </>
  );
}
